import { render, staticRenderFns } from "./CourseBox.vue?vue&type=template&id=eb789678&scoped=true&"
import script from "./CourseBox.vue?vue&type=script&lang=ts&"
export * from "./CourseBox.vue?vue&type=script&lang=ts&"
import style0 from "./CourseBox.vue?vue&type=style&index=0&id=eb789678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb789678",
  null
  
)

export default component.exports